export const versions = {
  version: "1.0.183",
  revision: "5a1136028",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5120-g5a1136028-dirty",
    hash: "g5a1136028",
    distance: 5120,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5120-g5a1136028-dirty",
    semverString: "1.0.183+5120.g5a1136028.dirty"
  }
};
